import { useTranslations } from 'next-intl';
import type { PinOnImageResult } from '@core-api/presentation/types/response';

interface ScreenReaderResultsProps {
  results: PinOnImageResult[];
  shouldHideResults: boolean;
  shouldShowCorrect: boolean;
}

export const ScreenReaderResults = ({
  results,
  shouldHideResults,
  shouldShowCorrect,
}: ScreenReaderResultsProps) => {
  const translate = useTranslations('presenting.screenreader_table');

  if (shouldHideResults) {
    return <span>{translate('results_are_hidden_message')}</span>;
  }

  const numberOfCorrectPins = results.reduce(
    (acc, result) =>
      acc +
      (result.correctAnswerStatus === 'correct' ? result.responseCount : 0),
    0,
  );
  const numberOfPins = results.reduce(
    (acc, result) => acc + result.responseCount,
    0,
  );

  return (
    <table>
      <caption>{translate('results_table_caption')}</caption>
      <thead>
        <tr>
          <th scope="col">{translate('total_number_of_pins_column_title')}</th>
          {shouldShowCorrect && (
            <th scope="col">
              {translate('number_of_correct_pins_column_title')}
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">{numberOfPins}</th>
          {shouldShowCorrect && <td>{numberOfCorrectPins}</td>}
        </tr>
      </tbody>
    </table>
  );
};
